import { MAIN_CONTENT_ID } from "../../utils/a11y";

export function SkipLink() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const main = document.getElementById(MAIN_CONTENT_ID);
    if (main instanceof HTMLElement) {
      main.focus();
      main.scrollIntoView();
    }
  };

  return (
    <a href={`#${MAIN_CONTENT_ID}`} className="skip-link" onClick={handleClick}>
      Zum Inhalt springen
    </a>
  );
}
